<template lang="html">
  <span class="p-1">
    <b-tooltip label="Change theme" type="is-warning" position="is-left">
      <b-button @click="isComponentModalActive = true" class="is-warning is-inverted">
        <b-icon icon="palette-outline"></b-icon> </b-button
    ></b-tooltip>

    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <!-- Header -->
        <header class="modal-card-head">
          <p class="modal-card-title">Change Theme</p>
        </header>

        <!-- Collections Selection -->
        <section class="modal-card-body">
          <b-field label="Themes">
            <b-select placeholder="Select a theme" rounded v-model="selectedTheme">
              <option v-for="(theme, index) in themes" :value="theme.id" :key="index">
                {{ theme.attributes.name }}
              </option>
            </b-select>
          </b-field>
        </section>

        <!-- Footer -->
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalActive = false">
            Close
          </button>
          <button class="button is-success" type="button" @click="updateTheme">
            Update
          </button>
        </footer>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { notificationMixin } from '@/mixins/notificationMixin'
import { textMixin } from '@/mixins/textMixin'

export default {
  props: ['theme', 'themableType', 'themableId'],
  mixins: [notificationMixin, textMixin],
  data () {
    return {
      selectedTheme: null,
      themes: [],
      isComponentModalActive: false
    }
  },
  created () {
    this.$store
      .dispatch('themes/index')
      .then((response) => {
        this.themes = response.data.data
      })
      .catch((error) => {
        console.log(error.response)
      })
    this.selectedTheme = this.theme.id
  },
  methods: {
    updateTheme () {
      this.$store
        .dispatch('themes/update', {
          themeId: this.selectedTheme,
          themableId: this.themableId,
          themableType: this.textPluralize(this.themableType.toLowerCase())
        })
        .then((response) => {
          this.actionSuccess('The theme has been updated')
          this.$emit('themeUpdated', response.data.data.attributes.theme.name)
          this.isComponentModalActive = false
        })
        .catch((error) => {
          console.log(error.response)
        })
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'isOwner',
      isLoggedIn: 'isLoggedIn',
      currentUser: 'currentUser'
    })
  }
}
</script>

<style lang="css" scoped></style>
